import { ISituacaoProcesso } from '../types';
import {listAll} from './api';

const endpoint = 'situacao-projeto';

export default {
    listAll: async () => listAll<any>({ endpoint }),
};
